var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#67C15E",
    fillRule: "evenodd",
    d: "M16.505 0C25.6 0 33 7.401 33 16.5S25.601 33 16.505 33c-3.356 0-6.468-.999-9.077-2.726l-6.342 2.027 2.056-6.13A16.379 16.379 0 0 1 0 16.5C0 7.4 7.399 0 16.495 0zm-6.216 7.547c-.63 0-1.29.184-1.688.592-.484.494-1.687 1.649-1.687 4.015 0 2.367 1.726 4.657 1.959 4.977.242.32 3.365 5.247 8.214 7.256 3.791 1.571 4.916 1.425 5.78 1.241 1.26-.271 2.84-1.203 3.238-2.328.398-1.125.398-2.086.281-2.29-.116-.203-.436-.32-.92-.562l-.227-.112c-.759-.377-2.665-1.312-3.061-1.45-.437-.165-.854-.106-1.183.36-.466.65-.921 1.31-1.29 1.707-.29.31-.766.349-1.164.184-.533-.223-2.026-.747-3.87-2.387-1.425-1.27-2.394-2.851-2.675-3.326-.282-.485-.03-.767.193-1.029.243-.3.475-.514.718-.795.242-.281.378-.427.533-.757.165-.32.049-.65-.068-.892-.116-.243-1.086-2.61-1.483-3.57-.32-.766-.563-.795-1.047-.815a9.315 9.315 0 0 0-.553-.019z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7ff3a7783151bcaa0fb5b673b0f93e67.svg";
export { ForwardRef as ReactComponent };